import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

/**
 * BorderContainer is a presentational component that wraps its children with a styled div.
 * It applies a set of utility classes for border, background, and layout, and merges any additional classes provided via the className prop.
 *
 * @param {ComponentProps<'div'>} props - Standard div props, including optional className and children.
 * @returns {JSX.Element} The styled container wrapping the provided children.
 */
function BorderContainer({ className, children, ...props }: ComponentProps<'div'>) {
  const classes = twMerge(`isolate w-full bg-background rounded-full overflow-hidden flex justify-between border-2 border-b-5 border-foreground`, className);
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}

export { BorderContainer };
